import { Trans } from "@lingui/macro";
import { UiButton } from "@smp/ui";
import { IconChevronLeft } from "@tabler/icons-react";
import { useFormikContext } from "formik";
import { FC, useCallback } from "react";

import { EStep, ICreateFormValues } from "../../create_form.types";

export interface IBackButtonProps {
  currentStep: EStep;
  onClick: () => void;
  isLoading: boolean;
}

export const BackButton: FC<IBackButtonProps> = ({
  currentStep,
  onClick,
  isLoading,
}) => {
  const { setFieldValue } = useFormikContext<ICreateFormValues>();

  const handleClick = useCallback(() => {
    if (currentStep === EStep.TARGET_AUDIENCE) {
      setFieldValue("middleData.target_audience", "");
    } else if (currentStep === EStep.PROBLEM) {
      setFieldValue("middleData.problem", "");
    }

    onClick();
  }, [currentStep, onClick, setFieldValue]);

  if (currentStep === EStep.OCCUPATION) {
    return null;
  }

  return (
    <UiButton
      startIcon={<IconChevronLeft />}
      size="large"
      disabled={isLoading}
      onClick={handleClick}
    >
      <Trans>Back</Trans>
    </UiButton>
  );
};
